import React from "react";
import ContractsPage from "@/components/contracts/ContractsPage";
export default function BuyerContracts()    { return <ContractsPage role="buyer"     title="Contracts" />; }
